import {
  Autocomplete,
  Box,
  Checkbox,
  FormControl,
  Grid,
  IconButton,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  Tooltip,
} from "@mui/material";
import { memo, useState } from "react";
import { Quarter, ls, ReportType } from "../variables";
import { useStateValue } from "../Hooks/stateProvider";
import Styles from "./styles/selectComponentStyles.module.css";
import InfoIcon from '@mui/icons-material/Info';

const SelectComponent = memo(
  ({
    selectedFinancialYear,
    setSelectedFinancialYear,
    selectedQuarter,
    setSelectedQuarter,
    // selectedHalfYearly,
    // setSelectedHalfYearly,
    selectedReportType,
    setSelectedReportType,
    // setFundOptions,
    compliance,
    selectedCompliance,
    setSelectedCompliance,
    selectedPMS,
    setSelectedPMS,
    pmsFlag,
    reportFlag,
  }) => {
    console.log({selectedCompliance});
    
    const [{ moduleType }, dispatch] = useStateValue();
    ls.set("ModuleType",moduleType)
    
    const [fundOptions, setFundOptions] = useState(
      ls.get("reportType")[moduleType]
    );
    const Year = ls.get("years");
    // const ITEM_HEIGHT = 48;
    // const ITEM_PADDING_TOP = 8;
    const fundOptionsObject = ls.get("reportType")["CMM"];
    console.log("key={item.code} ", fundOptionsObject);

    const handleSelectAll = (fundOptions) => {
      if (fundOptions?.every((id) => selectedPMS?.includes(id.code))) {
        setSelectedPMS([]);
      } else {
        setSelectedPMS(fundOptions.map((val) => val.code));
      }
    };

    const handleSelect = (id) => {
      //if it is already available then remove, if not then add.
      if (selectedPMS?.includes(id)) {
        setSelectedPMS(selectedPMS.filter((selectedId) => selectedId !== id));
      } else {
        setSelectedPMS([...selectedPMS, id]);
      }
    };

    return (
      <Grid container spacing={2} display="flex">
        {reportFlag && (
          <Grid
            item
            display="flex"
            className={Styles.dataForm}
            xs={12}
            sm={6}
            md={3}
            lg={3}
          >
            <FormControl
              variant="standard"
              sx={{ m: 0, height: "100%", width: "100%" }}
            >
              <span>Report Type</span>
              <Select
                value={selectedReportType}
                onChange={(e) => {
                  setSelectedReportType(e.target.value);
                  setFundOptions(
                    ls.get("reportType")[
                    e.target.value == "ALERT"
                      ? "Alert Processing"
                      : e.target.value
                    ]
                  );
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      color: "#000000",
                      "& .MuiMenuItem-root": {
                        padding: 1,
                      },
                    },
                  },
                }}
                displayEmpty
                renderValue={
                  selectedReportType !== "" ? undefined : () => "Select Report"
                }
              >
                {ReportType.map((name) => (
                  <MenuItem key={name.label} value={name.value}>
                    {name.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}
        <Grid
          item
          display="flex"
          className={Styles.dataForm}
          xs={12}
          sm={6}
          md={3}
          lg={3}
        >
          <FormControl
            variant="standard"
            sx={{ m: 0, height: "100%", width: "100%" }}
          >
            <span>Financial Year</span>
            <Select
              value={selectedFinancialYear}
              onChange={(e) => setSelectedFinancialYear(e.target.value)}
              MenuProps={{
                PaperProps: {
                  sx: {
                    color: "#000000",
                    "& .MuiMenuItem-root": {
                      padding: 1,
                    },
                  },
                },
              }}
              displayEmpty
              renderValue={
                selectedFinancialYear !== "" ? undefined : () => "Select FY"
              }
            >
              {Year.map((name) => (
                <MenuItem key={name.label} value={name.value}>
                  {name.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        {moduleType !== "CMM" && <Grid
          item
          display="flex"
          className={Styles.dataForm}
          xs={12}
          sm={6}
          md={3}
          lg={3}
        >
          {((ls.get("userType") == "SEBI") || (ls.get("userType") == "PMS")) && (
            <FormControl
              variant="standard"
              sx={{ m: 0, height: "100%", width: "100%" }}
            >
              <span>Quarter</span>
              <Select
                value={selectedQuarter}
                onChange={(e) => setSelectedQuarter(e.target.value)}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      "& .MuiMenuItem-root": {
                        padding: 1,
                      },
                    },
                  },
                }}
                displayEmpty
                renderValue={
                  selectedQuarter !== "" ? undefined : () => "Select Quarter"
                }
              >
                {Quarter.map((name) => (
                  <MenuItem key={name.label} value={name.value}>
                    {name.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        </Grid>}
        {pmsFlag && (
         <Grid item className={Styles.dataForm} xs={12} sm={6} md={4} lg={4}>
          <FormControl
              variant="standard"
              sx={{ m: 0, height: "100%", width: "100%" }}
            >
              <span>PMS</span>
              <Autocomplete
                multiple
                disableCloseOnSelect
                filterOptions={(options, state) => {
                  const filteredPMS = options.filter((option) =>
                    option.PMS.toLowerCase().includes(state.inputValue)
                  );
                  return filteredPMS;
                }}
                options={[{ code: "Select All", PMS: "Select All" }, ...fundOptionsObject]}
                getOptionKey={(option) => option.code}
                getOptionLabel={(option) => option.PMS}
                renderInput={(params) => {
                  const { endAdornment } = params.InputProps;

                  params.InputProps = {
                    ...params.InputProps,
                    endAdornment: (
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {endAdornment}
                        <Tooltip title="Search for the PMS name to obtain the corresponding PMS code" placement="top">
                          <IconButton size="small" sx={{ ml: 1 }}>
                            <InfoIcon fontSize="inherit" />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    )
                  };

                  return (
                    <TextField {...params} variant="standard" placeholder={selectedPMS.length > 0 ? selectedPMS.join(",") : "Select PMS"} />
                  )
                }}
                renderOption={(params, option) => {  // Rendering first 10 PMS names instead of 455 which causes lag issue
                  if (params['data-option-index'] < 10) {
                    return (
                      <Tooltip
                        title={`${option.PMS}`}
                        placement="top-start"
                        key={option.code}
                      >
                        <MenuItem
                          value={option.code}
                          onClick={() => option.code === "Select All" ? handleSelectAll(fundOptions) : handleSelect(option.code)}
                        >
                          <Checkbox checked={option.code === "Select All" ? fundOptions?.every((id) => selectedPMS.includes(id.code)) : selectedPMS.includes(option.code)} />
                          <ListItemText primary={option.code} />
                        </MenuItem>
                      </Tooltip>
                    )
                  } else return null
                }}
              />
            </FormControl>
          </Grid>
        )}
        {moduleType === "CMM" && compliance?.length > 0 && (
          <Grid
            item
            display="flex"
            className="dataForm"
            xs={12}
            sm={6}
            md={4}
            lg={4}
          >
            <FormControl
              variant="standard"
              sx={{ m: 0, height: "100%", width: "100%" }}
            >
              <span>CMM Type</span>
              <Select
                value={selectedCompliance}
                onChange={(e) => {
                  setSelectedCompliance(e.target.value);
                  dispatch({
                    type: "selectedCMMType",
                    cmmType: e.target.value,
                  });
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      color: "#000000",
                      "& .MuiMenuItem-root": {
                        padding: 1,
                      },
                    },
                  },
                }}
                displayEmpty
                renderValue={
                  selectedCompliance !== ""
                    ? undefined
                    : () => "Select Compliance"
                }
              >
                {compliance?.map((name) => (
                  <MenuItem key={name.label} value={name.value}>
                    {name.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}
        {reportFlag && (
          <Grid item className={Styles.dataForm} xs={12} sm={6} md={3} lg={3}>
            <FormControl
              variant="standard"
              sx={{ m: 0, height: "100%", width: "100%" }}
            >
              <span>
                {fundOptions.includes("KFINTECH") ||
                  fundOptions.includes("CAMS")
                  ? "PMS/RTA"
                  : "PMS"}
              </span>
              <Select
                value={selectedPMS}
                onChange={(e) => setSelectedPMS(e.target.value)}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      height: "fit-content",
                      maxHeight: "15rem",
                      color: "#000000",
                      "& .MuiMenuItem-root": {
                        padding: 1,
                      },
                    },
                  },
                }}
                displayEmpty
                renderValue={
                  selectedPMS !== "" ? undefined : () => "Select PMS"
                }
              >
                {fundOptionsObject.map((item, i) => {
                  console.log("ITEM>>>", i, item);
                  return (
                    <MenuItem value={item.code}>
                      <Tooltip
                        title={item.PMS}
                        placement="top-start"
                        key={item.code}
                      >
                        {item.code}
                      </Tooltip>
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
        )}
      </Grid>
    );
  }
);

export default SelectComponent;
